var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDineReward({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4406_480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 94,
    height: 94,
    rx: 8,
    fill: "#238856"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4406_480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.625 51C58.9312 51 51 58.9312 51 68.625C51 78.3188 58.9312 86.25 68.625 86.25C78.3188 86.25 86.25 78.3188 86.25 68.625C86.25 58.9312 78.3188 51 68.625 51ZM75.2344 70.8281H70.8281V75.2344C70.8281 76.5562 69.9469 77.4375 68.625 77.4375C67.3031 77.4375 66.4219 76.5562 66.4219 75.2344V70.8281H62.0156C60.6938 70.8281 59.8125 69.9469 59.8125 68.625C59.8125 67.3031 60.6938 66.4219 62.0156 66.4219H66.4219V62.0156C66.4219 60.6938 67.3031 59.8125 68.625 59.8125C69.9469 59.8125 70.8281 60.6938 70.8281 62.0156V66.4219H75.2344C76.5562 66.4219 77.4375 67.3031 77.4375 68.625C77.4375 69.9469 76.5562 70.8281 75.2344 70.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51 39.9844C46.1531 39.9844 42.1875 44.8313 42.1875 51C42.1875 55.6266 44.6109 59.5922 47.9156 61.3547C49.8984 55.6266 54.0844 51 59.5922 48.5766C58.7109 43.7297 55.1859 39.9844 51 39.9844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0469 26.7656H17.9531C16.6312 26.7656 15.75 27.6469 15.75 28.9688V73.0312C15.75 74.3531 16.6312 75.2344 17.9531 75.2344H47.6953C47.0344 73.2516 46.5938 70.8281 46.5938 68.625H31.1719C29.85 68.625 28.9688 67.7438 28.9688 66.4219C28.9688 63.9984 26.9859 62.0156 24.5625 62.0156C23.2406 62.0156 22.3594 61.1344 22.3594 59.8125V42.1875C22.3594 40.8656 23.2406 39.9844 24.5625 39.9844C26.9859 39.9844 28.9688 38.0016 28.9688 35.5781C28.9688 34.2562 29.85 33.375 31.1719 33.375H70.8281C72.15 33.375 73.0312 34.2562 73.0312 35.5781C73.0312 38.0016 75.0141 39.9844 77.4375 39.9844C78.7594 39.9844 79.6406 40.8656 79.6406 42.1875V49.6781C82.2844 51.2203 84.4875 53.2031 86.25 55.6266V28.9688C86.25 27.6469 85.3688 26.7656 84.0469 26.7656Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4406_480",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.717647 0 0 0 0 0.392157 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4406_480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4406_480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4406_480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70.5,
    height: 70.5,
    fill: "white",
    transform: "translate(15.75 15.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDineReward);
export default __webpack_public_path__ + "static/media/dine-reward.75398c787d4fdddef1ca1059ee097d1c.svg";
export { ForwardRef as ReactComponent };